import React from 'react';
import PropTypes from 'prop-types';
import { useIntl } from 'react-intl';

import DateTime from '../DateTime';

const DownloadRequestEditStatusHistory = ({ statuses }) => {
  const intl = useIntl();

  if (statuses.length === 0) {
    return null;
  }

  return (
    <div className="status-history">
      <h5>{intl.formatMessage({ defaultMessage: 'Status history' })}</h5>
      <div className="users-list status-history-list">
        {statuses.map((s, idx) => (
          <div key={`${idx + 1}`} className="user-item status-history-item">
            {s.user.avatar_url ? (
              <div className="user-avatar">
                <img src={s.user.avatar_url} alt={s.user.name} className="avatar avatar-30" />
              </div>
            ) : (
              <div className="user-avatar avatar avatar-30 icon-avatar gray">
                <i className="fas fa-user" />
              </div>
            )}
            <div className="user-item-body">
              <h6 className="user-item-title status-history-text">
                <span className="user-name">{s.user.name}</span>
                {(statuses[idx + 1] && s.status === statuses[idx + 1].status) ? (
                  <>
                    {intl.formatMessage({ defaultMessage: 'commented' })}
                  </>
                ) : (
                  <>
                    {intl.formatMessage({ defaultMessage: 'changed status to' })}{' '}
                    {s.status === 'pending' && (
                      <span className="status-history-status status-history-pending">
                        <i className="fas fa-hourglass-half" />
                        <span>{intl.formatMessage({ defaultMessage: 'Pending' })}</span>
                      </span>
                    )}
                    {s.status === 'accepted' && (
                      <span className="status-history-status status-history-accepted">
                        <i className="far fa-check" />
                        <span>{intl.formatMessage({ defaultMessage: 'Accepted' })}</span>
                      </span>
                    )}
                    {s.status === 'rejected' && (
                      <span className="status-history-status status-history-rejected">
                        <i className="far fa-times" />
                        <span>{intl.formatMessage({ defaultMessage: 'Rejected' })}</span>
                      </span>
                    )}
                  </>
                )}
                <DateTime
                  id={`log-date-${idx}`}
                  className="status-history-date"
                  dateTime={s.created_at}
                />
              </h6>
              {s.comment && (
                <span className="status-history-comment">
                  <strong>{intl.formatMessage({ defaultMessage: 'Comment' })}</strong>: {s.comment}
                </span>
              )}
            </div>
          </div>
        ))}
      </div>
    </div>
  );
};

DownloadRequestEditStatusHistory.propTypes = {
  statuses: PropTypes.array.isRequired,
};

export default DownloadRequestEditStatusHistory;
